/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1024px){.subscription-bar-visible[_ngcontent-%COMP%], .subscription-bar-visible[_ngcontent-%COMP%]   #m_aside_left[_ngcontent-%COMP%]{margin-top:30px!important}}@media (max-width:1024px){.subscription-bar-visible[_ngcontent-%COMP%]   .m-wrapper[_ngcontent-%COMP%]{margin-top:30px!important}}"];
export { styles as styles };
